// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import WidgetReservationListResourceViewModel from '../../../../viewModel/resource/WidgetReservationListResourceViewModel';
import WidgetReservationListResourceDTO from '../../dto/resource/WidgetReservationListResourceDTO';

export default abstract class WidgetReservationListResourceModel extends BaseModel<WidgetReservationListResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get eventName() { return this.dto.eventName; }
  set eventName(value) { this.dto.eventName = value; }
  /**
  * @type {date-time}
  */
  get startDate() { return this.dto.startDate; }
  set startDate(value) { this.dto.startDate = value; }
  /**
  * @type {date-time}
  */
  get endDate() { return this.dto.endDate; }
  set endDate(value) { this.dto.endDate = value; }
  /**
  */
  get rooms() { return this.dto.rooms; }
  set rooms(value) { this.dto.rooms = value; }
  /**
  */
  get lecturers() { return this.dto.lecturers; }
  set lecturers(value) { this.dto.lecturers = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.eventName = qs.eventname;
    this.dto.startDate = qs.startdate;
    this.dto.endDate = qs.enddate;
  }
}
